<template>
  <OverlayFrame
    :zIndex="overlayZIndex"
    placement="center"
    :title="title"
    :subtitle="subtitle"
    :icon="icon"
    :closeOnScrim="closeOnScrim"
    @close="emit('close')"
  >
    <div class="stack tight">
      <UiQuantity v-model="qty" :min="min" :max="max" :step="step" :disabled="disabled" />
      <div v-if="helperText" class="text-muted">{{ helperText }}</div>

      <div class="row wrap" style="justify-content: flex-end;">
        <UiButton size="sm" variant="secondary" :disabled="disabled" @click="emit('close')">Cancel</UiButton>
        <UiButton size="sm" :disabled="disabled" @click="confirm">{{ confirmLabel }}</UiButton>
      </div>
    </div>
  </OverlayFrame>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { ICONS } from "../../lib/icons";
import OverlayFrame from "./OverlayFrame.vue";
import UiButton from "../ui/UiButton.vue";
import UiQuantity from "../ui/UiQuantity.vue";

const props = withDefaults(
  defineProps<{
    overlayZIndex?: number;
    title: string;
    subtitle?: string | null;
    icon?: string;
    min?: number;
    max?: number;
    step?: number;
    initial?: number;
    confirmLabel?: string;
    helperText?: string | null;
    disabled?: boolean;
    closeOnScrim?: boolean;
    onConfirm?: (value: number) => void;
  }>(),
  {
    overlayZIndex: 4200,
    subtitle: null,
    icon: ICONS.actions.quantity,
    min: 1,
    max: 1,
    step: 1,
    initial: 1,
    confirmLabel: "Confirm",
    helperText: null,
    disabled: false,
    closeOnScrim: true,
    onConfirm: undefined
  }
);

const emit = defineEmits<{
  close: [];
}>();

const qty = ref<number>(Math.max(props.min, Math.min(props.max, Math.floor(props.initial))));

watch(
  () => [props.min, props.max, props.initial] as const,
  ([min, max, initial]) => {
    const next = Math.max(min, Math.min(max, Math.floor(initial)));
    qty.value = next;
  }
);

function confirm() {
  const value = Math.max(props.min, Math.min(props.max, Math.floor(qty.value)));
  props.onConfirm?.(value);
}

onMounted(() => {
  qty.value = Math.max(props.min, Math.min(props.max, Math.floor(props.initial)));
});
</script>

